import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { changePage } from './store/actions/query';
import { retrieveRecords, filterOptionsAsQueryParameter } from './store/actions/search';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faSearch } from '@fortawesome/pro-solid-svg-icons';

import CsvDownloadButton from  'components/csv_download_button';
import LoadingSpinner from 'components/loading_spinner';
import SearchPage from 'components/search_page';
import PageHeader from 'components/page_header';

import WebhookEventsTable from './webhook_events_table';
import WebhookEventFilterTopbar from './webhook_event_filter_topbar';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';
import queryString from 'query-string';

export class WebhookEvents extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    isFetchingWebhookEvents: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool.isRequired,
    paths: PropTypes.shape({
      webhookEventsCsvPath: PropTypes.string
    }).isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    webhookEvents: PropTypes.array.isRequired,
    onPageChange: PropTypes.func.isRequired
  }

  componentDidMount() {
    this.props.retrieveRecords();
  }

  scrollPanel = React.createRef();

  handlePageChange = (page) => {
    this.props.onPageChange(page);
    this.props.retrieveRecords();
    this.scrollToTop();
  };

  csvDownloadPath() {
    const filters = filterOptionsAsQueryParameter(this.props.query);
    const paramsQueryString = queryString.stringify(filters, { arrayFormat: 'bracket' });
    return `${this.props.paths.webhookEventsCsvPath}?${paramsQueryString}`;
  }

  render() {
    return (
      <React.Fragment>
        <SearchPage>
          <div className="results-tab-container">
            {this.renderPageHeader()}
            <WebhookEventFilterTopbar />
            <div className="table-content">
              <div className="main-content" ref={this.scrollPanel}>
                {this.renderResults()}
                {this.renderPagination()}
              </div>
            </div>
          </div>
        </SearchPage>
      </React.Fragment>
    );
  }

  renderPageHeader() {
    return (
      <PageHeader
        iconDescription="View existing webhook events"
        iconName={faCalendarCheck}
        iconSize="lg"
        iconText="Webhook Events"
        iconType="icon"
      >
        <div className="pull-right row-eq-height">
          <CsvDownloadButton href={this.csvDownloadPath()} type="Button" />
        </div>
      </PageHeader>
    );
  }

  renderResults() {
    const { webhookEvents, isFetchingWebhookEvents, totalCount } = this.props;

    if (isFetchingWebhookEvents) {
      return (
        <div className="centered-image">
          <LoadingSpinner />
        </div>
      );
    } else if (webhookEvents.length > 0) {
      return (
        <WebhookEventsTable />
      );
    } else if (totalCount === 0) {
      return (
        <div className="centered-image">
          {this.renderNoResults()}
        </div>
      );
    }
  }

  renderNoResults() {
    return (
      <div className="no-results-panel" name="noResults">
        <FontAwesomeIcon className="text-muted mt-4" icon={faSearch} size="5x"/>
        <h4 className="mt-4">
          <strong className="text-lg">No results found</strong>
        </h4>
        <p className="text-muted mb-4">Search with different criteria</p>
      </div>
    );
  }

  renderPagination() {
    if (!this.props.isFetchingWebhookEvents) {
      if (this.props.webhookEvents.length >= this.props.totalCount) return <div className="my-5" />;

      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={this.props.currentPage}
            totalPages={this.props.totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  const isFiltered = !(
    state.query.searchText === '' &&
    state.query.eventTypeFilter.length === 0 &&
    state.query.identifier === '' &&
    state.query.maxDate === null &&
    state.query.minDate === null &&
    state.query.statusFilter.length === 0
  );

  return {
    ...state.search.meta,

    webhookEvents: state.search.webhookEvents,
    isFetchingWebhookEvents: state.search.isFetching,
    isFiltered,
    paths: state.paths,
    query: state.query
  };
};

const mapDispatchToProps = {
  onPageChange: changePage,
  retrieveRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookEvents);
